import "./styles/index.scss";

import focus from "@alpinejs/focus";
import intersect from "@alpinejs/intersect";
import resize from "@alpinejs/resize";
import Alpine from "alpinejs";

document.addEventListener("DOMContentLoaded", function () {
  window.Alpine = Alpine;
  Alpine.plugin([resize, intersect, focus]);
  Alpine.start();
});

document.addEventListener("alpine:init", () => {
  Alpine.data("cycleIndex", (itemsCount) => ({
    switchIndex: 0,
    itemsCount: itemsCount,

    init() {
      setInterval(() => {
        this.switchIndex = (this.switchIndex + 1) % itemsCount;
      }, 2000);
    },
  }));

  Alpine.data("gallery", () => ({
    init() {
      selectedIndex = 0;
      last = false;

      this.$nextTick(() => {
        // Get the Flickity instance via its element.
        // Flickity.data() is useful for getting the Flickity instance in JavaScript,
        // after it has been initalized in HTML.
        const flick = Flickity.data(this.$refs.slides);
        // fixes resize issue in Safari and ios:
        // resize gallery when in loaded in viewport after timeout
        if (flick) {
          setTimeout(() => {
            flick.resize();
          }, 250);
        }
      });
    },

    // fixes resize issue in Safari and ios:
    // resize gallery when intersecting later
    // run this function on x-intersect.once
    resize() {
      const flick = Flickity.data(this.$refs.slides);
      if (flick) {
        setTimeout(() => {
          flick.resize();
        }, 250);
      }
    },

    prev() {
      Flickity.data(this.$refs.slides).previous();
    },

    next() {
      Flickity.data(this.$refs.slides).next();
    },
  }));

  Alpine.data("contentCarousel", () => ({
    init() {
      // first we add data-flickity to given element as well as x-ref="slides"
      // since we don't have access to the element in the template in InnerBlocks
      this.$el
        .querySelector(".content-carousel")
        .setAttribute("x-ref", "slides");

      // initialize Flickity with the given options
      this.$el
        .querySelector(".content-carousel")
        .setAttribute(
          "data-flickity",
          '{"contain": true, "cellAlign": "left", "pageDots": true, "prevNextButtons": false, "setGallerySize": false }'
        );

      this.$nextTick(() => {
        // Get the Flickity instance via its element.
        // Flickity.data() is useful for getting the Flickity instance in JavaScript,
        // after it has been initalized in HTML.
        const flick = Flickity.data(this.$refs.slides);
        // resize gallery,
        // fixes resize issue in Safari and ios
        if (flick) {
          console.log("flickEl", flick);
          flick.resize();
        }
      });
    },
  }));
});
